import { useEffect } from "react";
import { TopBar } from "../../shared/topBar/TopBar"

export const CilentReturnsDetails=()=>{
    useEffect(()=>{
        document.title="Details"
    },[]);
    return <>
    <TopBar label={"Client Return Details"} />
        <div  className="mainContentData">
         
        </div>
    </>
}